/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { IoSync } from "react-icons/io5";
import { IoIosCloseCircleOutline, IoIosLock } from "react-icons/io";
import { LuSend } from "react-icons/lu";
import { Image } from "react-bootstrap";
import ExpandableInput from "./ExpandableInput";


const htmlToPlainWithNewlines = (html = "") => {
  if (!html) return "";

  let s = String(html)
    .replace(/<\s*br\s*\/?>/gi, "\n")
    .replace(/<\/\s*p\s*>/gi, "\n")
    .replace(/<\/\s*div\s*>/gi, "\n")
    .replace(/<\/\s*li\s*>/gi, "\n")
    .replace(/<li\b[^>]*>/gi, "• ")
    .replace(/<\/?[^>]+(>|$)/g, "")
    .replace(/&nbsp;/g, " ");

  // keep internal spacing, just reduce extreme newlines
  s = s.replace(/\n{3,}/g, "\n\n");

  // IMPORTANT: no trim here (trim breaks typing spaces at edges)
  return s;
};

const plainWithNewlinesToHtml = (text = "") => {
  if (text === null || text === undefined) return "";

  const safe = String(text).trimEnd();
  if (!safe) return "";

  const paragraphs = safe.split(/\n\s*\n/);

  // ✅ Single paragraph: no <p>, no default margins
  if (paragraphs.length === 1) {
    return paragraphs[0].replace(/\n/g, "<br/>");
  }

  // ✅ Multiple paragraphs: wrap but kill margins
  return paragraphs
    .map((p) => `<p style="margin:0;">${p.replace(/\n/g, "<br/>")}</p>`)
    .join("");
};

const SubmitArea = ({
  selectedReceiver,
  myIds,
  setIsTyping,
  imagesArray,
  imageLinks,
  handleRemoveImage,
  fileUpload,
  editorState,
  handleKeyPress,
  handleSubmit,
  chatDisable,
  editMode,
  docId,
  setEditId,
  editText,
  setEditText,
  handleEdit,
  showButtons = true,
  isAiBotMode = false,
	getAIResponse = () => { },
	toggleAiBotMode = () => { },
	isAITyping = false,
	setMessageContent = () => { },
	isInModal = true,
	readPersonalChats = [],
	processPlainTextMessage
}) => {
  const [message, setMessage] = useState("");

  // Separate draft for editing, so we don't keep converting / trimming while typing
  const [editDraft, setEditDraft] = useState("");

  const lastEditKeyRef = useRef(null);

  const [{ LoginData }, { personalConnections }] = useSelector((state) => [
    state.user,
    state.firebase,
  ]);

  // Initialize edit draft when edit starts / message changes
  useEffect(() => {
    const editKey = editMode ? `${docId || ""}` : null;

    // Only re-init draft when switching to a different message edit
    if (editMode && editKey && lastEditKeyRef.current !== editKey) {
      lastEditKeyRef.current = editKey;

      // editText might be HTML (stored message body) or plain text — handle both
      const plain = htmlToPlainWithNewlines(editText || "");
      setEditDraft(plain);
      return;
    }

    // when leaving edit mode, cleanup
    if (!editMode) {
      lastEditKeyRef.current = null;
      setEditDraft("");
    }
  }, [editMode, docId, editText]);

  const safeRunHandleEdit = (id, html) => {
    // If handleEdit accepts (docId, html), use it
    if (typeof handleEdit === "function" && handleEdit.length >= 2) {
      handleEdit(id, html);
      return;
    }

    // Otherwise fallback: update editText state to html then call handleEdit(docId)
    setEditText(html);
    handleEdit(id);
  };

  	const handleSend = () => {
		 const processedPlain = processPlainTextMessage(message);
		if (isAiBotMode) {
			getAIResponse({ message: processedPlain });
		}
    const html = plainWithNewlinesToHtml(processedPlain.trimEnd());

		handleSubmit({ type: "simple", encodedString: `<p>${html}</p>`, rawMessage:message });
		setMessage(''); 
	};


	const allQuestions = LoginData?.isTaxPro
		? [
			"How do I explain the tax savings of an S-Corp to a client?",
			"What questions should I ask during a tax planning sales call?",
			"How do I structure a plan for a client with an LLC and short-term rentals?",
			"How should I price and position a $5K–$10K tax plan offer?"
		]
		: [
			"What tax write-offs am I probably missing right now?",
			"Can you check if I'm overpaying in taxes this year?",
			"How can I legally pay $0 in taxes like the wealthy?",
			"Is an LLC or S-Corp better for my situation?"
		];

  const askedQuestions = readPersonalChats.map((msg) => {
    if (!msg.body) return "";
    return msg.body
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/\\n|\\|&nbsp;/g, "")
      .trim()
      .toLowerCase();
  });

  const aiSuggestionQuestions = allQuestions.filter(
    (question) => !askedQuestions.includes(question.trim().toLowerCase())
  );

  const handleSubmitAI = ({ message }) => {
    const mess = `<p>${message}</p>`;
    getAIResponse({ message: mess });
    handleSubmit({ type: "simple", encodedString: mess });
  };

  const inputValue = editMode ? editDraft : message;

  return (
    <div
      className={`clearfix p-md-2 ${
        chatDisable && "disabled"
      } editor w-100 px-1`}
      style={isInModal ? { bottom: 0 } : { top: 0 }}
    >
      {LoginData?.userpro?.status_id === 6 && (
        <>
          <div className="editor-overlay"></div>
          <div className="editor-danger-text gap-2">
            <IoIosLock style={{ fontSize: "20px", color: "#a8a8a8" }} />{" "}
            <p className="text-danger fw-bold">
              Chat is currently disabled. Please contact support to reactivate
              your account
            </p>
          </div>
        </>
      )}
      <div className="isTypingArea position-relative d-flex align-items-start justify-content-end flex-column gap-1">
        {personalConnections?.data
          ?.find(
            (data) =>
              data?.ids?.includes(myIds[1]) && data?.ids?.includes(myIds[0])
          )
          ?.isTyping?.includes(selectedReceiver?.uuid) ? (
          <small className="isType-text">
            {selectedReceiver?.firstname + " " + selectedReceiver?.lastname} is
            Typing....
          </small>
        ) : (
          ""
        )}
        {isAITyping && isAiBotMode && (
          <small className="isType-text">Ask UNK is typing…</small>
        )}
        {!isAiBotMode && (
          <div className="start-0 d-flex align-items-start justify-content-center flex-column gap-1">
            <small className="text-black">
               {LoginData?.isTaxPro
                ? "Need help with a client?"
                : "Need tax answers fast?"}
            </small>
            <button
              className="btn btn-sm btn-light border border-primary text-primary py-2 d-flex align-items-center justify-content-between flex-row rounded-3"
              onClick={() => toggleAiBotMode(true)}
            >
              <Image
                src={require("../../assets/icons/spiritual.png")}
                width={12}
                height={12}
                style={{ marginLeft: 10 }}
              />
              <p className="m-0 p-0 mx-2">Switch to Ask UNK AI</p>
            </button>
          </div>
        )}
        {isAiBotMode && (
          <>
            <div className="d-flex flex-nowrap overflow-hidden position-relative">
              <div
                className="d-flex flex-nowrap pb-2"
                style={{
                  overflowX: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  width: isInModal ? 350 : "120vh",
                }}
              >
                {aiSuggestionQuestions?.map((data, index) => (
                  <div
                    className="btn btn-sm btn-outline-primary flex-shrink-0 m-0 p-0 px-2 py-1 rounded rounded-2 me-1"
                    key={index}
                    onClick={() => handleSubmitAI({ message: data })}
                  >
                    <span style={{ fontSize: 12 }}>{data}</span>
                  </div>
                ))}
              </div>
              <div
                className="position-absolute top-0 end-0 h-100 w-25"
                style={{
                  background:
                    "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
                  pointerEvents: "none",
                }}
              ></div>
            </div>
            {LoginData?.isTaxPro && (
              <small className="text-muted fs10">
                UNK is an AI assistant and not a licensed tax advisor. Please
                review all outputs before using them with customers.
              </small>
            )}
            {LoginData?.isCustomer && (
              <small className="text-muted fs10">
                UNK is an AI assistant and not a licensed tax advisor. Your tax
                pro will review all strategy recommendations.
              </small>
            )}
          </>
        )}
      </div>

      <div className="w-100 d-flex flex-row align-items-center justify-content-start  flex-wrap px-2">
        {imageLinks?.map((image, index) => (
          <div key={index} className="image-container">
            <div className="delete-icon animation-div">
              <Link onClick={() => handleRemoveImage(image)}>
                <IoIosCloseCircleOutline size={23} />
              </Link>
            </div>
            <img
              src={image.downloadURL}
              alt={`Unique ${index}`}
              className="rounded-2 upload-image shadow-sm rounded"
            />
          </div>
        ))}
        {imagesArray?.map((image, index) => {
          let loading = imageLinks.find((e) => e.path === image.path);
          return (
            <div key={index} className="image-container">
              {loading === undefined && (
                <>
                  <div className="circle-animation d-flex align-items-center justify-content-center">
                    <IoSync size={12} />
                  </div>
                  <img
                    src={URL.createObjectURL(image)}
                    alt={`Unique ${index}`}
                    className="rounded-2 upload-image shadow-sm rounded"
                  />
                </>
              )}
            </div>
          );
        })}
      </div>

      <form onSubmit={(e) => e.preventDefault()}>
        <div 
          className={`w-100 border border-light d-flex align-items-center justify-content-between flex-row p-1 chat-input rounded rounded-2 flex-wrap:nowrap `}
        >
          <div
            className="position-relative rounded-2 border border-1"
            style={{ width: "91.8%", backgroundColor: "#FFFFFF" }}
            ref={setIsTyping}
          >
            <ExpandableInput
              value={inputValue}
              onChange={(newValue) => {
                if (editMode) setEditDraft(newValue);
                else setMessage(newValue);
              }}
              onSend={(value) => {
                const processedPlain = processPlainTextMessage(value);
                // Edit mode: Enter saves edit with formatting preserved
                if (editMode) {
                  const html = plainWithNewlinesToHtml(processedPlain.trimEnd());
                  safeRunHandleEdit(docId, html);
                  setEditDraft("");
                  setEditId?.(null);
                  return;
                }
                // Normal send
                if (isAiBotMode) getAIResponse({ message: processedPlain });
                const html = plainWithNewlinesToHtml(processedPlain.trimEnd());
                handleSubmit({
                  type: "simple",
                  encodedString: html,
                  rawMessage: value,
                });
                setMessage("");
              }}
              onKeyPress={handleKeyPress}
            />

            {!isAiBotMode && (
              <div
                className="px-2 py-1 rounded rounded-5 position-absolute"
                style={{ backgroundColor: "#ECEDF4", bottom: 8, right: 8 }}
              >
                <Image
                  src={require("../../assets/icons/gallery.png")}
                  width={17}
                  height={17}
                  role="button"
                  onClick={() => {
                    if (document.getElementById("image-picker")) {
                      document.getElementById("image-picker").click();
                    }
                  }}
                />
              </div>
            )}
          </div>
          <div className="d-flex flex-row ml-1 rounded rounded-2 mx-1">
            {showButtons && (
              <div className="d-flex align-items-center gap-1">
                {!editMode ? (
                  <div>
                    <Link
                      className={
                        LoginData?.isCustomer
                          ? "btn btn-primary px-1 py-2 ml-1 btn-sm d-flex align-items-center"
                          : "btn btn-primary px-3 px-sm-2 py-2 ml-md-2 ml-1 btn-sm d-flex align-items-center gap-1"
                      }
                      onClick={() => handleSend()}
                    >
                      {!isInModal && <font className="mx-1">Send</font>}
                      <LuSend
                        size={13}
                        className={LoginData?.isCustomer ? "mb-1.5" : "mb-1"}
                      />
                    </Link>
                  </div>
                ) : (
                  <div className="d-flex gap-2 mx-2">
                    <Link
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => {
                        setEditDraft("");
                        setEditText("");
                        setEditId(null);
                      }}
                    >
                      cancel
                    </Link>
                    <Link
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => {
                        const processedPlain = processPlainTextMessage(editDraft);
                        const html = plainWithNewlinesToHtml(processedPlain.trimEnd());
                        safeRunHandleEdit(docId, html);
                        setEditDraft("");
                        setEditId?.(null);
                      }}
                    >
                      save
                    </Link>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </form>
      <input
        type="file"
        accept="image/*"
        className="d-none"
        id="image-picker"
        onChange={(e) => {
          fileUpload(e.target.files[0], "add");
        }}
        onClick={(e) => (e.target.value = "")}
      />
    </div>
  );
};

export default SubmitArea;
